/*
 * Widget that allows filtering a list of users by their status
 */

define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "./userStatusFilterView",
  "modules/admin/userAdministration/usersModel",
], function (Backbone, Marionette, Messenger, UserStatusFilterView, UsersModel) {
  "use strict";

  const UserStatusFilterController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userStatusFilter";
      this.region = options.region;
      this.namespace = options.namespace;
      this.namespacePrefix = this.namespace ? this.namespace + ":" : "";
    },
    show: function () {
      const model = new Backbone.Model({
        userStatusSelected: UsersModel.USER_STATUS_ALL,
        userStatusFilterValues: Messenger.reqres.request("user:statuses", true),
      });

      this.view = new UserStatusFilterView.userStatusFilterView({
        model: model,
      });
      this.view.on("change:userStatusFilter", this._changeUserStatusFilter.bind(this));
      this.view.on("show", this._onShow.bind(this));
      this.showRegion(this.view);
    },
    _changeUserStatusFilter: function (userStatusSelected) {
      this.view.model.set("userStatusSelected", userStatusSelected);
      Messenger.vent.trigger(
        this.namespacePrefix + "set:external:filter",
        this._filterActiveUsers.bind(this),
      );
    },
    _filterActiveUsers: function (model) {
      const userStatusSelected = this.view.model.get("userStatusSelected");
      return (
        userStatusSelected == UsersModel.USER_STATUS_ALL ||
        userStatusSelected == model.get("enabledStatus")
      );
    },
    _onShow: function () {
      Messenger.vent.trigger(
        this.namespacePrefix + "set:external:filter",
        this._filterActiveUsers.bind(this),
      );
    },
  });

  return UserStatusFilterController;
});
